import { useQuery } from 'react-query';
import { getAuthenticatedApiClient } from '../api-client';

const getCategories = () =>
  getAuthenticatedApiClient()
    .getEventCategories()
    .then((x) => x.data);

export const useGetEventCategories = () => useQuery('event-categories', getCategories);
